import { render } from "./thirdPartySharing.vue?vue&type=template&id=bae492b2"
const script = {}

import "./thirdPartySharing.vue?vue&type=style&index=0&id=bae492b2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__